export default __webpack_public_path__ + "static/media/CNo.67-1.4886bdf8.jpg";